import { useCallback, useRef, useState } from 'react'

/**
 * for handling Status Messages across MFC App
 * @returns
 */
export const useStatusMessage = () => {
    const [statusMessage, setStatusMessage] = useState<string>()
    const [showStatus, setShowStatus] = useState(false)

    const timers = useRef({
        show: undefined,
        hide: undefined,
        clear: undefined,
    })

    const onStatusMessage = useCallback((value: string) => {
        clearTimeout(timers.current.show)
        clearTimeout(timers.current.hide)
        clearTimeout(timers.current.clear)
        setStatusMessage(value)
        timers.current.show = setTimeout(() => setShowStatus(true), 50)
        timers.current.hide = setTimeout(() => setShowStatus(false), 3000)
        timers.current.clear = setTimeout(
            () => setStatusMessage(undefined),
            3300,
        )
    }, [])

    return {
        showStatus,
        statusMessage,
        setShowStatus,
        setStatusMessage,
        onStatusMessage,
    }
}
